<template>
  <span v-if="showEmpty" class="ack-status-pill-empty">—</span>
  <span
    v-else
    class="ack-status-pill"
    :class="pillClass"
  >
    {{ label || '—' }}
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  statusKey: { type: String, default: null },
  label: { type: String, default: '' },
});

const pillClass = computed(() => {
  const key = props.statusKey;
  const map = {
    no_acknowledgement: 'no-acknowledgement',
    pending_acknowledgement: 'incomplete',
    job_profile_id_changed: 'job-profile-changed',
    job_profile_content_changed: 'job-profile-changed',
    acknowledgement_out_of_date: 'out-of-date',
    acknowledgement_ok: 'completed',
    cancelled: 'cancelled',
    inactive: 'inactive',
  };

  return map[key] || null;
});

const showEmpty = computed(() => {
  if (!props.statusKey) return true;
  return !pillClass.value;
});
</script>

<style lang="less" scoped>
.ack-status-pill-empty {
  color: @text-light;
}

.ack-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 0 8px;
  height: 24px;
  max-height: 24px;
  border-radius: 50px;
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  box-sizing: border-box;

  &.inactive {
    background: @grey-200;
    color: @text-light;
    border-color: @grey-500;
  }

  &.no-acknowledgement {
    background: @red-100;
    color: @red-700;
    border-color: @red-300;
  }

  &.incomplete {
    background: @orange-100;
    color: @orange-700;
    border-color: @orange-300;
  }

  &.job-profile-changed {
    background: @yellow-100;
    color: @yellow-700;
    border-color: @yellow-300;
  }

  &.out-of-date {
    background: @navy-100;
    color: @navy-700;
    border-color: @navy-300;
  }

  &.completed {
    background: @teal-100;
    color: @teal-700;
    border-color: @teal-300;
  }

  &.cancelled, &.inactive {
    background: @grey-200;
    color: @text-light;
    border-color: @grey-500;
  }
}
</style>
